import React from 'react';
import './indicacionDetalle.scss';
import { Grid } from '@mui/material';

export const IndicacionDetalleHeader = ({ data, esMedico }) => {

    return (
        <Grid container className='contrato-card'>
            <Grid size={{ xs: 12 }}>
                <div className='section-title'>Contrato actual</div>
            </Grid>
            <Grid container spacing={1} size={{ xs: 12 }}>
                <Grid size={{ xs: 12, md: 2 }}>
                    <div className='contrato-card-label'>HC</div>
                    <div>{data?.idPaciente}</div>
                </Grid>
                <Grid size={{ xs: 12, md: 3 }}>
                    <div className='contrato-card-label'>Paciente</div>
                    <div>{data?.paciente}</div>
                </Grid>
                <Grid size={{ xs: 12, md: 1 }}>
                    <div className='contrato-card-label'>Edad</div>
                    <div>{data?.edad}</div>
                </Grid>
                {
                    esMedico &&
                    <Grid size={{ xs: 12, md: 3 }}>
                        <div className='contrato-card-label'>Alergias</div>
                        <div>{data?.alergias}</div>
                    </Grid>
                }
                <Grid size={{ xs: 12, md: 1 }}>
                    <div className='contrato-card-label'>Contrato</div>
                    <div>{data?.contratoActual}</div>
                </Grid>
                <Grid size={{ xs: 12, md: (esMedico) ? 2 : 3 }}>
                    <div className='contrato-card-label'>Fecha contrato</div>
                    <div>{data?.fechaContratoActual}</div>
                </Grid>
                {
                    !esMedico &&
                    <Grid size={{ xs: 12, md: 2 }}>
                        <div className='contrato-card-label'>Precio diario</div>
                        <div>{data?.precioDiario}</div>
                    </Grid>
                }
                <Grid size={{ xs: 12, md: 5 }}>
                    <div className='contrato-card-label'>Cliente</div>
                    <div>{data?.cliente}</div>
                </Grid>
                <Grid size={{ xs: 12, md: 1 }}>
                    <div className='contrato-card-label'>Programa</div>
                    <div>{data?.programa}</div>
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    <div className='contrato-card-label'>Plan</div>
                    <div>{data?.planCuidado}</div>
                </Grid>
            </Grid>
        </Grid>
    )
}